import { render, staticRenderFns } from "./DialogUploadsFile.vue?vue&type=template&id=124eebc2&"
import script from "./DialogUploadsFile.vue?vue&type=script&lang=js&"
export * from "./DialogUploadsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports